/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DataInnerValue
 */
export interface DataInnerValue {
}

/**
 * Check if a given object implements the DataInnerValue interface.
 */
export function instanceOfDataInnerValue(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DataInnerValueFromJSON(json: any): DataInnerValue {
    return DataInnerValueFromJSONTyped(json, false);
}

export function DataInnerValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataInnerValue {
    return json;
}

export function DataInnerValueToJSON(value?: DataInnerValue | null): any {
    return value;
}

